import { useFeatureFlag } from '@bonusly/who-am-i';

export enum Variant {
	HideRewards = 'hide-rewards',
	AchieveEarlyAccess = 'one-on-ones',
	AchieveLimitedRelease = 'achieve-limited-release',
}

/**
 * @deprecated Prefer `useFeatureFlag` from `@bonusly/who-am-i` instead.
 */
export const useVariantEnabled = useFeatureFlag;
